export default "__VITE_ASSET__72aad997__"